export default __webpack_public_path__ + "static/media/kodas.bd014b25.png";